import { useState, useEffect } from 'react';

export default function useCountdown() {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      // Set deadline to Jan 10, 2026 (event day - last day for registration)
      const deadline = new Date('Jan 10, 2026 15:00:00').getTime();
      const now = new Date().getTime();

      // Use actual deadline if it's in the future, otherwise use demo deadline
      let targetDeadline = deadline;
      if (deadline < now) {
        // For demo purposes, if the real date is passed, fake a deadline 8 days from "now"
        const demoDeadline = new Date();
        demoDeadline.setDate(demoDeadline.getDate() + 8);
        targetDeadline = demoDeadline.getTime();
      }

      const t = targetDeadline - now;

      if (t > 0) {
        return {
          days: Math.floor(t / (1000 * 60 * 60 * 24)),
          hours: Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((t % (1000 * 60 * 60)) / (1000 * 60)),
        };
      }

      return { days: 0, hours: 0, minutes: 0 };
    };

    setTimeLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return timeLeft;
}